<template>
  <section>
    <div>
      <b-table
        :data="areas"
        :loading="loading"
        :hoverable="true"
        :narrowed="true"
        :mobile-cards="true"
        paginated
        backend-pagination
        backend-sorting
        :total="total"
        :per-page="perPage"
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        @page-change="onPageChange"
        @sort="onSort"
      >
        <b-table-column
          field="sort"
          :label="$t('attributes.sort')"
          width="150"
          sortable
          numeric
          centered
          v-slot="props"
        >
          {{ props.row.sort }}
        </b-table-column>
        <b-table-column
          field="name"
          :label="$t('attributes.area_name')"
          width="250"
          sortable
          numeric
          centered
          v-slot="props"
        >
          {{ props.row.area_code }}{{ props.row.area.name }}
        </b-table-column>
        <b-table-column
          field="status"
          :label="$t('attributes.status')"
          width="150"
          sortable
          numeric
          centered
          v-slot="props"
        >
          <b-tag
            :type="props.row.status === 'Y' ? 'is-info' : 'is-danger'"
            size="is-medium"
          >
            {{ props.row.status === 'Y' ? '上架' : '下架' }}
          </b-tag>
        </b-table-column>
        <b-table-column
          :label="$t('attributes.function')"
          width="250"
          centered
          v-slot="props"
        >
          <b-button type="is-info" @click.prevent.stop="onModify(props.row)">
            {{ $t('attributes.modify') }}
          </b-button>
        </b-table-column>
      </b-table>
    </div>

    <b-modal
      :active.sync="isModelActive"
      :can-cancel="['escape', 'x']"
      has-modal-card
    >
      <honey-moon-area-form
        :detail="selectedItem"
        @send="onSend"
      ></honey-moon-area-form>
    </b-modal>
  </section>
</template>

<script>
import { HONEY_MOON_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import HoneyMoonAreaForm from '@/components/company/HoneyMoonAreaForm'

export default {
  name: 'HoneyMoonAreaList',
  components: { HoneyMoonAreaForm },
  data() {
    return {
      sending: false,
      loading: false,
      areas: [],

      selectedItem: null,
      isModelActive: false,
      total: 0,
      sortField: 'sort',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',
      page: 1,
      perPage: 15
    }
  },
  mounted() {
    this.loadProjAreas()
  },
  methods: {
    async loadProjAreas() {
      this.loading = true
      const api = `${HONEY_MOON_API}/list/proj_area`
      try {
        const res = await this.axios.get(api)
        this.areas = res.data.data
        this.loading = false
      } catch (e) {
        this.loading = false
        this.areas = []
        notifyService.fetch_error('country', e)
      }
    },
    onPageChange(page) {
      this.onSelect(null)
      this.page = page
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
    },
    onModify(item) {
      this.selectedItem = item
      this.isModelActive = true
    },
    async onSend(item) {
      const api = `${HONEY_MOON_API}/update/proj_area`
      try {
        this.sending = true
        await this.axios.put(api, item)
        notifyService.success(this.$t('attributes.update_succeed'))

        await this.loadProjAreas()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
